	<!-- Loader -->
		<div id="global-loader" *ngIf="Loading">
			<img src="../assets/img/loader.svg" class="loader-img" alt="Loader">
		</div>
		<!-- /Loader -->
  <div id="popup" class="ol-popup">
    <a href="#" id="popup-closer" class="ol-popup-closer"></a>
    <div id="popup-content"></div>
  </div>
		<!-- Page -->
		<div class="page">

			<div>
				<!-- main-header -->
				<div class="main-header side-header sticky nav nav-item"  style="height: 70px;">
					<div class=" main-container container-fluid">
						<div class="main-header-left " style="margin-left: -264px;">
							<div class="responsive-logo">
								<a routerLink="/" class="header-logo">
									<img src="../../assets/img/brand/logo_andf.jpg"  width="95" height="64" style="align-items: left;" class="mobile-logo logo-1" alt="logo">
									<!-- <img src="../../assets/img/brand/logo_andf.jpg" class="mobile-logo dark-logo-1" alt="logo"> -->
								</a>
							</div>
							<div class="app-sidebar__toggle" data-bs-toggle="sidebar">
								<a class="open-toggle" href="javascript:void(0);"><i class="header-icon fe fe-align-left" ></i></a>
								<a class="close-toggle" href="javascript:void(0);"><i class="header-icon fe fe-x"></i></a>
							</div>
							<div class="logo-horizontal" style="display: block;" >
								<a routerLink="/" class="header-logo">
									<!-- <img src="../../assets/img/brand/logo_andf.jpg" width="95" height="65" style="align-items: left;" class="mobile-logo logo-1" alt="logo"> -->
									<img src="../../assets/img/brand/logo_andf.jpg" style="display: block;" width="95" height="70" class="mobile-logo dark-logo-1" alt="logo">
								</a>
							</div>
							<div class="main-header-center ms-4 d-sm-none d-md-none d-lg-block form-group" >
								<input style="margin-left: 50px;" class="form-control" [(ngModel)]="search" name="search" placeholder="Rechercher votre parcelle par le nup" type="search">
								<button class="btn" (click)="SearchByNup(search)" >
									<img src="../../assets/search.png" style="margin-left: 10px;" width="25" height="25" alt="picto">
                </button>
							</div>
						</div>
						<div class="main-header-right">
							<button class="navbar-toggler navresponsive-toggler d-lg-none ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent-4" aria-controls="navbarSupportedContent-4" aria-expanded="false" aria-label="Toggle navigation">
								<span class="navbar-toggler-icon fe fe-more-vertical "></span>
							</button>
							<div class="mb-0 navbar navbar-expand-lg navbar-nav-right responsive-navbar navbar-dark p-0">
								<div class="collapse navbar-collapse" id="navbarSupportedContent-4">
									<ul class="nav nav-item header-icons navbar-nav-right ms-auto">
										<!-- <li class="dropdown nav-item">
											<a class="new nav-link" data-bs-target="#country-selector" data-bs-toggle="modal" href=""><svg class="header-icon-svgs" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9h-2.764a14.67 14.67 0 0 0-1.792-6.243A8.013 8.013 0 0 1 19.931 11zM12.53 4.027c1.035 1.364 2.427 3.78 2.627 6.973H9.03c.139-2.596.994-5.028 2.451-6.974.172-.01.344-.026.519-.026.179 0 .354.016.53.027zm-3.842.7C7.704 6.618 7.136 8.762 7.03 11H4.069a8.013 8.013 0 0 1 4.619-6.273zM4.069 13h2.974c.136 2.379.665 4.478 1.556 6.23A8.01 8.01 0 0 1 4.069 13zm7.381 6.973C10.049 18.275 9.222 15.896 9.041 13h6.113c-.208 2.773-1.117 5.196-2.603 6.972-.182.012-.364.028-.551.028-.186 0-.367-.016-.55-.027zm4.011-.772c.955-1.794 1.538-3.901 1.691-6.201h2.778a8.005 8.005 0 0 1-4.469 6.201z"/></svg></a>
										</li> -->
										<li class="dropdown nav-item">
											<a class="new nav-link theme-layout nav-link-bg layout-setting" >
												<span class="dark-layout"><svg xmlns="http://www.w3.org/2000/svg" class="header-icon-svgs" width="24" height="24" viewBox="0 0 24 24"><path d="M20.742 13.045a8.088 8.088 0 0 1-2.077.271c-2.135 0-4.14-.83-5.646-2.336a8.025 8.025 0 0 1-2.064-7.723A1 1 0 0 0 9.73 2.034a10.014 10.014 0 0 0-4.489 2.582c-3.898 3.898-3.898 10.243 0 14.143a9.937 9.937 0 0 0 7.072 2.93 9.93 9.93 0 0 0 7.07-2.929 10.007 10.007 0 0 0 2.583-4.491 1.001 1.001 0 0 0-1.224-1.224zm-2.772 4.301a7.947 7.947 0 0 1-5.656 2.343 7.953 7.953 0 0 1-5.658-2.344c-3.118-3.119-3.118-8.195 0-11.314a7.923 7.923 0 0 1 2.06-1.483 10.027 10.027 0 0 0 2.89 7.848 9.972 9.972 0 0 0 7.848 2.891 8.036 8.036 0 0 1-1.484 2.059z"/></svg></span>
												<span class="light-layout"><svg xmlns="http://www.w3.org/2000/svg" class="header-icon-svgs" width="24" height="24" viewBox="0 0 24 24"><path d="M6.993 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007S14.761 6.993 12 6.993 6.993 9.239 6.993 12zM12 8.993c1.658 0 3.007 1.349 3.007 3.007S13.658 15.007 12 15.007 8.993 13.658 8.993 12 10.342 8.993 12 8.993zM10.998 19h2v3h-2zm0-17h2v3h-2zm-9 9h3v2h-3zm17 0h3v2h-3zM4.219 18.363l2.12-2.122 1.415 1.414-2.12 2.122zM16.24 6.344l2.122-2.122 1.414 1.414-2.122 2.122zM6.342 7.759 4.22 5.637l1.415-1.414 2.12 2.122zm13.434 10.605-1.414 1.414-2.122-2.122 1.414-1.414z"/></svg></span>
											</a>
										</li>
										<li class="nav-item full-screen fullscreen-button">
											<a class="new nav-link full-screen-link" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" class="header-icon-svgs" width="24" height="24" viewBox="0 0 24 24"><path d="M5 5h5V3H3v7h2zm5 14H5v-5H3v7h7zm11-5h-2v5h-5v2h7zm-2-4h2V3h-7v2h5z"/></svg></a>
										</li>
                    <li class="nav-item ">
											<a class="new nav-link" (click)="getGeoPoistion()">
                        <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2c-4.963 0-9 4.038-9 9 0 3.328 1.82 6.232 4.513 7.79l-2.067 1.378A1 1 0 0 0 6 22h12a1 1 0 0 0 .555-1.832l-2.067-1.378C19.18 17.232 21 14.328 21 11c0-4.962-4.037-9-9-9zm0 16c-3.859 0-7-3.141-7-7 0-3.86 3.141-7 7-7s7 3.14 7 7c0 3.859-3.141 7-7 7z"/><path d="M12 6c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"/></svg>
                      </a>
										</li>
										<li class="dropdown main-header-message right-toggle">
											<a class="new nav-link nav-link pe-0" data-bs-toggle="sidebar-right" data-bs-target=".sidebar-right">
												<svg xmlns="http://www.w3.org/2000/svg" class="header-icon-svgs" width="24" height="24" viewBox="0 0 24 24"><path d="M4 6h16v2H4zm4 5h12v2H8zm5 5h7v2h-7z"/></svg>
											</a>
										</li>
										<li class="nav-link search-icon d-lg-none d-block">
											<form class="navbar-form" role="search">
												<div class="input-group">
													<input type="text" class="form-control" placeholder="Search">
													<span class="input-group-btn">
														<button type="reset" class="btn btn-default">
															<i class="fas fa-times"></i>
														</button>
														<button type="submit" class="btn btn-default nav-link resp-btn">
															<svg xmlns="http://www.w3.org/2000/svg" height="24px" class="header-icon-svgs" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
														</button>
													</span>
												</div>
											</form>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- /main-header -->
			</div>


      <div class="content" role="main">
        <div  id="map" class="map"></div>
<!--        <div class="radar"  [ngStyle]="radarStyle"></div>-->
        <div class="radar" [ngClass]="{'active': radarActive}" [ngStyle]="radarStyle"></div>
        <div id="scaleline">
          <!--      <div id="cdt" > </div>-->
        </div>




<div class="btn-group ms-2 mt-2 mb-2 legende">
  <div class="dropdown">
    <button style="font-size: 18px; font-weight: bold; color: #125699; background-color: #fff; " aria-expanded="false"
      aria-haspopup="true" class="btn ripple btn-light" data-bs-toggle="dropdown" id="dropdownMenuButton3"
      type="button">
      Légende
      <i class="fe fe-chevron-down ms-1"></i>
    </button>
    <div class="dropdown-menu tx-13">

      <li >
        <a  class="dropdown-item" href="#" >
          <div  id="legendeName" > Parcelle TF Etat/Communale</div>
          <div class="pTF"></div>
        </a>
      </li>

      <li >
        <a  class="dropdown-item" href="#" >
          <div  id="legendeName" > Parcelle TF Etat/Communale</div>
          <div class="pTF"></div>
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          <div id="legendeName"> Parcelle TF particulier</div>
          <div class="sTF"></div>
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          <div id="legendeName"> Parcelle avec propriétaire présumé </div>
          <div class="dTF"></div>
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          <div id="legendeName"> Domaine public</div>
          <div class="dP"></div>
        </a>
      </li>
      <li>
        <a class="dropdown-item" href="#">
          <div id="legendeName"> Parcelles sans nom </div>
          <div class="otherS"></div>
        </a>
      </li>

    </div>
  </div>
</div>


<div class="btn-group ms-2 mt-2 mb-2 couche">
  <div class="dropdown">
    <button style="font-size: 18px; font-weight: bold; color: #125699; background-color: #fff; " aria-expanded="false"
      aria-haspopup="true" class="btn ripple btn-light" data-bs-toggle="dropdown" id="dropdownMenuButton3"
      type="button">
      Couches
      <i class="fas fa-caret-down ms-1"></i>
    </button>
    <div class="dropdown-menu tx-13">
      <li *ngFor="let tm of TypeMap">
        <a class="dropdown-item" href="#">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="openMapCh" [(ngModel)] = "openMapCh" value={{tm.value}} id="openMap1" (change)="openMapStreetCheck()">
             <label id="label" class="form-check-label" for="openMap1" >
              {{tm.name}}
             </label>
          </div>
        </a>
      </li>
    </div>
  </div>
</div>

<!-- <a class="btn ripple btn-primary" data-bs-target="#myModal" data-bs-toggle="modal" href="">View Demo</a> -->
<div class="modal  fade" id="myModal"  style="top: 25%; right: -64%;">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-content-demo">
      <div class="modal-header">
        <h2>
          Informations de la parcelle :
          <span style="color: #125699; font-weight: bold;">{{code}}</span>
        </h2>
        <button aria-label="Close" style="background-color: #fff;" class="btn-close" data-bs-dismiss="modal" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="row row-xs formgroup-wrapper">

          <div class="col-md mg-t-10 mg-md-t-0">

            <div class="main-form-group">
              <label class="form-label card-title">Numéro Unique Parcelaire</label>
              <input class="form-control" name="nup" [(ngModel)]="nup" placeholder="EX: 1000***96" type="text" disabled>
            </div>
            <!-- main-form-group -->
          </div>
          <div class="col-md mg-t-10 mg-md-t-0">

            <div class="main-form-group">
              <label class="form-label card-title">N° Titre</label>
              <input class="form-control fc-datepicker" name="Tfoncier" [(ngModel)]="Tfoncier" placeholder="EX: 140" type="texte" disabled>
            </div>
            <!-- main-form-group -->
          </div>

        </div>

        <div class="row row-xs formgroup-wrapper">

          <div class="col-md mg-t-10 mg-md-t-0">

            <div class="main-form-group">
              <label class="form-label card-title">Département</label>
              <input class="form-control" name="Dep" [(ngModel)]="Dep" placeholder="EX: Litoral" type="text" disabled>
            </div>
            <!-- main-form-group -->
          </div>
          <div class="col-md mg-t-10 mg-md-t-0">

            <div class="main-form-group">
              <label class="form-label card-title">Commune</label>
              <input class="form-control fc-datepicker"  name="Com" [(ngModel)]="Com" placeholder="EX: Cotonou" type="texte" disabled>
            </div>
            <!-- main-form-group -->
          </div>

        </div>

        <div class="row row-xs formgroup-wrapper">

          <div class="col-md mg-t-10 mg-md-t-0">

            <div class="main-form-group">
              <label class="form-label card-title">Arrondisement</label>
              <input class="form-control" name="Arr" [(ngModel)]="Arr" placeholder="EX: 11 éme Arrondissement" type="text" disabled>
            </div>
            <!-- main-form-group -->
          </div>
          <div class="col-md mg-t-10 mg-md-t-0">

            <div class="main-form-group">
              <label class="form-label card-title">Quartier/Village</label>
              <input class="form-control fc-datepicker" name="Qrtier" [(ngModel)]="Qrtier" placeholder="EX: Gbégamey" type="texte" disabled>
            </div>
            <!-- main-form-group -->
          </div>

        </div>

        <div class="row row-xs formgroup-wrapper">

          <div class="col-md mg-t-10 mg-md-t-0">

            <div class="main-form-group">
              <label class="form-label card-title">Superficie (m²)</label>
              <input class="form-control" name="Surface" [(ngModel)]="Surface" placeholder="EX: 900 m²" type="text" disabled>
            </div>
            <!-- main-form-group -->
          </div>
          <div class="col-md mg-t-10 mg-md-t-0">

            <div class="main-form-group">
              <label class="form-label card-title">Type Parcelle</label>
              <input class="form-control fc-datepicker" name="Parcelle" [(ngModel)]="Parcelle" placeholder="EX: Domaine public" type="texte" disabled>
            </div>
            <!-- main-form-group -->
          </div>

        </div>


      </div>
      <div class="modal-footer" style="float: right;">
        <!-- <button class="btn ripple btn-primary" type="button">Save changes</button> -->
        <button  class="btn ripple btn-default " data-bs-dismiss="modal" type="button">Fermer</button>
      </div>
    </div>
  </div>
</div>


<div *ngIf="showForm" id="draggable" class="card" >

  <!-- <span  class="btn btn-default" style="font-weight: bold; font-size: 20px; position: absolute; top: 0; right: 5px;"  >X</span> -->
  <div class="card-body">
      <h2>
          Informations de la parcelle :
          <span style="color: #125699; font-weight: bold;">{{code}}</span>
      </h2>
      <form >
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">NUP</label>
              <input type="text" class="form-control" name="nup" [(ngModel)]="nup" placeholder="-" disabled>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">N° Titre Foncier</label>
              <input type="text" class="form-control" name="Tfoncier" [(ngModel)]="Tfoncier" placeholder="-" disabled>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">Département</label>
              <input type="text" class="form-control" name="Dep" [(ngModel)]="Dep" placeholder="-" disabled>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">Communes</label>
              <input type="text" class="form-control" name="Com" [(ngModel)]="Com" placeholder="-" disabled>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">Arrondissement</label>
              <input type="text" class="form-control" name="Arr" [(ngModel)]="Arr" placeholder="-" disabled>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">Quartier</label>
              <input type="text" class="form-control" name="Qrtier" [(ngModel)]="Qrtier" placeholder="-" disabled>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">Surface estimée (m²)</label>
              <input type="email" class="form-control" name="Surface" [(ngModel)]="Surface" placeholder="" disabled>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">Parcelle</label>
              <input type="text" class="form-control" name="Parcelle" [(ngModel)]="Parcelle" placeholder="-" disabled>
            </div>
          </div>
        </div>
      </form>
      <button type="button" class="btn btn-default" (click)="close_pop_up()" > Fermer</button>
  </div>
</div>
</div>



